import React, { FC } from "react";

import { Chip, ChipProps } from "@mui/material";

/**
 * @see Chip
 */

export const IgChip: FC<ChipProps> = (props) => {
  const { children, ...rest } = props;

  return <Chip {...rest}>{children}</Chip>;
};
